import React, {useState, useEffect} from 'react';
import ComponentOption from '../contanerOptions/ComponentOption';
import {motion} from 'framer-motion';

const Pedidos =()=>{

    const [dataPedidos, setDataPedidos] = useState('');


    return(
        
        <ComponentOption>

            <div className="container">
                <div className="pl-5 pt-4"> <motion.h1 initial={{opacity:0}} animate={{opacity:1}} transition={{motion:0.6}} className="text-lg  sm:text-2xl font-bold uppercase pb-3">Pedidos </motion.h1></div>
                <div className="bg-gray-200 rounded-2xl p-5">
                    <motion.div initial={{x:4, opacity:0}} animate={{x:0, opacity:1}}>
                        <h1>Todos los pedidos de los diferentes producto/servicios  los recibirá en su Whatsapp, nuestra plataforma le permite crear un catalogo de productos o servicios las cuales se mostraran a los distintos clientes que ingresen a la plataforma. </h1>
                        <span>Para ver mas información haga clic sobre el link  : </span>
                        <a className="underline text-green-800" href="#">ver mas.</a>
                    </motion.div>
                    <div>

                    </div>
                </div>
            </div>
        </ComponentOption>
    );
}

export default Pedidos;